export const colorPropMixin = (colorProp: string, alpha = 1): string =>
  alpha >= 1 ? `rgb(var(${colorProp}))` : `rgba(var(${colorProp}), ${alpha})`;
